import { z } from 'zod'

// Re-export ParkedLine from utils for convenience
export { type ParkedLine } from '../utils/parkedLines'

// Zod schema for ParkedLine
export const ParkedLineSchema = z.object({
  line_id: z.number(),
  quantity: z.number(),
})

// Single parking iteration (used in parking_history array)
export const ParkingHistoryEntrySchema = z.object({
  parked_at: z.string(),
  parked_by: z.string(),
  parked_lines: z.array(ParkedLineSchema),
  parked_comment: z.string(),
  parked_photo_url: z.string(),
})

export type ParkingHistoryEntry = z.infer<typeof ParkingHistoryEntrySchema>

// Parking metadata stored in app_orders.app_data (current/latest parking)
export const ParkingMetadataSchema = z.object({
  parked_at: z.string().datetime(),
  parked_by: z.string().optional(),
  parked_reason: z.string().optional(),
  parked_lines: z.array(ParkedLineSchema).optional(),
  parked_comment: z.string().optional(),
  parked_photo_url: z.string().url().optional(),
  parking_history: z.array(ParkingHistoryEntrySchema).optional(),
  edit_history: z.array(z.object({
    changed_by: z.string(),
    changed_at: z.string(),
  })).optional(),
})

export type ParkingMetadata = z.infer<typeof ParkingMetadataSchema>

// Edit log entry for tracking who modified a parked order
export interface ParkedEditLog {
  changed_by: string   // email
  changed_at: string   // ISO timestamp
}

// Editable line state for tracking parked/open quantities during editing
export interface EditableLineState {
  line_id: number
  totalQty: number     // Total order quantity
  parkedQty: number    // Amount in parked (0 = fully open)
  openQty: number      // Amount open (0 = fully parked)
}
